// Imports => Constants
import { ENDPOINTS } from '@constants';

// Imports => Utilities
import { AcMemoize } from '@utils';

export class KpisAPI {
	constructor(Instance) {
		this.Store = Instance.Store;
		this.Client = Instance.Client;
	}

	index = AcMemoize(() => {
		return this.Client.get(ENDPOINTS.KPIS.INDEX).then((response) => response.data);
	});
}

export default KpisAPI;
